import { BaseSchemaFormComponent } from './components/base-schema-form/base-schema-form.component';
import { EditorSchemaFormComponent } from './components/editor-schema-form/editor-schema-form.component';
import { UserSchemaFormComponent } from './components/user-schema-form/user-schema-form.component';
import {
	CustomStringWidgetComponent,
	CustomIntegerWidgetComponent,
	CustomSelectWidgetComponent,
} from './components/widgets';
import { CustomWidgetRegistry } from './custom-widget-registry';
import { SfValidationErrorPipe } from './pipes/sf-validation-error.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectComponent } from '@app/shared/components/select/select.component';
import { SharedModule } from '@app/shared/shared.module';
import { SchemaFormModule as SfModule, WidgetRegistry } from 'ngx-schema-form';

const CUSTOM_COMPONENTS = [
	CustomStringWidgetComponent,
	CustomIntegerWidgetComponent,
	CustomSelectWidgetComponent,
];

@NgModule({
	imports: [SfModule.forRoot(), ReactiveFormsModule, CommonModule, SharedModule, SelectComponent],
	declarations: [
		BaseSchemaFormComponent,
		UserSchemaFormComponent,
		EditorSchemaFormComponent,
		SfValidationErrorPipe,
		...CUSTOM_COMPONENTS,
	],
	providers: [{ provide: WidgetRegistry, useClass: CustomWidgetRegistry }],
	exports: [
		BaseSchemaFormComponent,
		UserSchemaFormComponent,
		EditorSchemaFormComponent,
		SfValidationErrorPipe,
		...CUSTOM_COMPONENTS,
	],
})
export class SchemaFormModule {}
